import React from "react";

function Footer() {
  const handleSearch = (searchText) => {
    const searchUrl = `https://search.naver.com/search.naver?query=${encodeURIComponent(
      searchText
    )}`;
    window.open(searchUrl, "_blank");
  };

  return (
    <footer className="bg-gray-900 text-white py-4 w-full">
      <div className="container mx-auto flex justify-between items-center">
        <div
          className="text-xl font-nanum font-light cursor-pointer"
          onClick={() => handleSearch("아이엠플러스교육심리센터")}>
          아이엠플러스교육심리센터
        </div>

        <div className="flex space-x-6">
          <a
            href="https://blog.naver.com/iamplus904"
            className="text-gray-400 hover:text-white">
            블로그
          </a>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
